
import storeCode from '~/mixins/storeCode'

export default {
  name: 'CheckoutHeader',

  mixins: [
    storeCode,
  ],

  data () {
    return {
      isNavbarOpen: false,
    }
  },
}
